import React from 'react';
import Page from './page.layout';
import { Box } from '../../shared/components';
import Header from '../components/Header2.component';

export default function HeaderPage({
  actionButtons, title, children, navigationButton, overrideHeader, ...rest
}) {
  const width = document.body.clientWidth - 64 - 48;
  const height = document.body.clientHeight - 64 - 48;
  return (
    <Box>
      <Header
        style={{
          height: { height },
          width: { width },
          color: '#2E384D',
          fontFamily: 'Rubik',
          fontSize: '15px',
          fontWeight: '500',
          lineHeight: '18px !important',
          textAlign: 'center',
        }}
        overrideContent={overrideHeader}
        title={title}
        navigationButton={navigationButton}
        actionButtons={actionButtons}
      />
      <Page {...rest} style={{ paddingTop: '64px' }}>{children}</Page>
    </Box>
  );
}
